/**
 * format Price in standard format of $40.00 (two decimal places)
 * @param  {string} price
 * @param  {string} currency
 * @param {Object} options
 * @return {string}
 */
import { logError } from 'utils';
import { currencySymbol } from 'dictionary';
export default function(price, currency, options) {
  if (options === undefined) {
    options = { absolute: true };
  }
  let { absolute } = options;
  if (!price) {
    return `${currencySymbol(currency)}0`;
  }
  if (currency === undefined || currency === null) {
    logError('Currency comes either empty,null or undefined');
    return `${(Math.round(price * 100) / 100).toFixed(2)}`;
  }
  if (absolute) {
    return `${currencySymbol(currency)}${(
      Math.round(Math.abs(price * 100)) / 100
    ).toFixed(2)}`;
  }
  if (currency) {
    return `${price < 0 ? '-' : ''}${currencySymbol(currency)}${(
      Math.round(Math.abs(price * 100)) / 100
    ).toFixed(2)}`;
  }
  return `${(Math.round(price * 100) / 100).toFixed(2)}`;
}
